<div class="content" *ngIf="InOrOut === 'SEARCH' || InOrOut === 'IN' || InOrOut === 'OUT' || (InOrOut === 'DELIVERIES' && reservationData != null && reservationData.length > 0) || (InOrOut === 'COLLECTIONS' && reservationData != null && reservationData.length > 0) ">
  <div class="group-header">{{ (
    InOrOut === 'SEARCH' ? 'bikeshop.rentals.summary.search_results' :
    InOrOut === 'IN' ? 'bikeshop.rentals.summary.reservation_returning' :
    InOrOut === 'OUT' ? 'bikeshop.rentals.summary.reservation_going_out' : 
    InOrOut === 'DELIVERIES' ? 'bikeshop.rentals.summary.reservation_deliveries' : 
    InOrOut === 'COLLECTIONS' ? 'bikeshop.rentals.summary.reservation_collections' : ''
  ) | translate}}
<span *ngIf="InOrOut === 'DELIVERIES' || InOrOut === 'COLLECTIONS'" [ngClass]="{'flip': InOrOut === 'COLLECTIONS'}"><daz-icon name="truck_duo" [size]="'26px'" [color]="'var(--hubtiger-primary)'"></daz-icon></span>  
</div>
  <div class="reservation-header">
    <div class="chevron"></div>
    <!-- <div class="avatar"></div> -->
    <div *ngIf="InOrOut === 'SEARCH'">{{ 'bikeshop.rentals.summary.leaving_time' | translate }}</div>
    <div *ngIf="InOrOut === 'SEARCH'">{{ 'bikeshop.rentals.summary.returning_time' | translate }}</div>
    <div *ngIf="InOrOut !== 'SEARCH'">{{ (       
      InOrOut === 'IN' ? 'bikeshop.rentals.summary.returning_time' : 
      InOrOut === 'OUT' ? 'bikeshop.rentals.summary.leaving_time' :
      InOrOut === 'DELIVERIES' ? 'bikeshop.rentals.summary.delivery_time' :
      InOrOut === 'COLLECTIONS' ? 'bikeshop.rentals.summary.collection_time' : ''
  ) | translate }}</div>
    <!-- <div>{{ (InOrOut === 'IN' ? 'bikeshop.rentals.summary.returning_date' : 'bikeshop.rentals.summary.leaving_date') | translate }}</div> -->
    <div>{{ 'bikeshop.rentals.summary.reservation_number' | translate }}</div>
    <div>{{ 'bikeshop.rentals.summary.customer' | translate }}</div>
    <div class="rental-summary">{{ 'bikeshop.rentals.summary.product_summary' | translate }}</div>
    <div>{{ 'bikeshop.rentals.summary.payment_status' | translate }}</div>
    <div>{{ 'bikeshop.rentals.summary.waiver_signed' | translate }}</div>
    <div class="reservation-status">{{ 'bikeshop.rentals.summary.reservation_status' | translate }}</div>
    <!-- <div class="action-spacer"></div> -->
  </div>
  <div *ngIf="loading" style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <div *ngFor="let reservation of reservationData">
    <div class="reservation-row" (click)="openReservation(reservation)">
      <div class="chevron" (click)="expandReservation($event, reservation)"><span class="fa"
                                 [ngClass]="{'fa-chevron-down': reservation.id == expandedReservation.id, 'fa-chevron-right': reservation.id != expandedReservation.id}"></span>
      </div>
      <div class="time" *ngIf="InOrOut === 'SEARCH'">
        <div>{{reservation.fromDate | date : "h:mma"}}</div>
        <div>{{reservation.fromDate | date : countryData.angularDateFormat}}</div>
      </div>
      <div class="time" *ngIf="InOrOut === 'SEARCH'">
        <div>{{reservation.toDate | date : "h:mma"}}</div>
        <div>{{reservation.toDate | date : countryData.angularDateFormat}}</div>  
      </div>
      <div class="time" *ngIf="InOrOut !== 'SEARCH'">
        <div *ngIf="InOrOut === 'IN' || InOrOut === 'OUT'">{{(InOrOut === 'IN' ? reservation.toDate : reservation.fromDate) | date : "h:mma"}}</div>
        <div *ngIf="InOrOut === 'DELIVERIES'">{{ ('1970-01-01T'+(reservation.deliveryInformation ? reservation.deliveryInformation.scheduleTimeSlotStart : "00:00")) | date : "h:mma"}} - {{ ('1970-01-01T'+(reservation.deliveryInformation ? reservation.deliveryInformation.scheduleTimeSlotEnd : "00:00")) | date : "h:mma"}}</div>
        <div *ngIf="InOrOut === 'COLLECTIONS'">{{ ('1970-01-01T'+(reservation.collectionInformation ? reservation.collectionInformation.scheduleTimeSlotStart : "00:00")) | date : "h:mma"}} - {{ ('1970-01-01T'+(reservation.collectionInformation ? reservation.collectionInformation.scheduleTimeSlotEnd : "00:00")) | date : "h:mma"}}</div>
        <div>{{(InOrOut === 'IN' ? reservation.toDate : reservation.fromDate) | date : countryData.angularDateFormat}}
        </div>
        <div>
          <span *ngIf="reservation.duration && reservation.duration.days"
                style="margin-right: 4px">{{reservation.duration.days}}
            {{(reservation.duration.days === 1 ? 'bikeshop.rentals.booking.day' : 'bikeshop.rentals.booking.days') |
              translate}}</span><span
          *ngIf="reservation.duration && reservation.duration.hours">{{reservation.duration.hours}}
          {{(reservation.duration.hours === 1 ? 'bikeshop.rentals.booking.hour' : 'bikeshop.rentals.booking.hours') |
            translate}}</span>
        </div>
      </div>
      <!-- <div class="standard-column">{{(InOrOut === 'IN' ? reservation.toDate : reservation.fromDate) | date : countryData.angularDateFormat}}</div> -->
      <div class="reservation-column">
        <div>#{{reservation.reservationNumber}} <span *ngIf="reservation.isDemo">({{ 'bikeshop.rentals.booking.type_demo' | translate }})</span></div>
        <div *ngIf="reservation.affiliateName" class="affiliate"><span
          class="hubtiger-shop-profile"></span>{{reservation.affiliateName}}</div>
      </div>
      <div class="standard-column" style="    flex-direction: column;align-items: flex-start;">
        <div>{{reservation.customer}}</div>
        <div *ngIf="InOrOut === 'DELIVERIES'" class="address">{{ reservation.deliveryInformation ? reservation.deliveryInformation.fullAddress : "" }}</div>
        <div *ngIf="InOrOut === 'COLLECTIONS'" class="address">{{ reservation.collectionInformation ? reservation.collectionInformation.fullAddress : "" }}</div>
      </div>
      <div class="rental-summary">
        <div>
          <div *ngFor="let item of reservation.reservationProducts;let i = index;">
            <div><span *ngIf="reservation.reservationProducts.length > 1">{{i + 1}}
              . </span>{{item.brand}} {{item.model}}</div>
            <!-- <ul>
              <li *ngFor="let item of item.reservationAccessories">{{item.brand}} {{item.name}}</li>
            </ul> -->
          </div>
        </div>
      </div>
      <div class="payment-status">
        <div [ngClass]="{
        'not-paid': reservation.paymentStatusID === 0,
        'partially-paid': reservation.paymentStatusID === 1 || reservation.paymentStatusID === 2,
        'paid': reservation.paymentStatusID === 10,
        'partially-refunded': reservation.paymentStatusID === 19,
        'refunded': reservation.paymentStatusID === 20

      }">{{reservation.paymentStatus}}</div>
      </div>
      <div class="standard-column waiver-status">
        <div [ngClass]="{
        'signed': waiversSignedInt(reservation) === 1,
        'not-signed': waiversSignedInt(reservation) === 0,
        'partially-signed': waiversSignedInt(reservation) === 2
      }">{{ waiversSigned(reservation) | translate }}</div>
      </div>
      <div class="reservation-status" style="margin-top: 0px;">
        <p-dropdown [options]="reservationStatuses" [(ngModel)]="reservation.reservationStatusID" optionValue="key" optionLabel="label" (click)="statusClick($event)" (onChange)="statusUpdated(reservation)"
            styleClass="full-width-dropdown"/>
      </div>
      <!-- <div class="action">
        <div (click)="openReservation(reservation)"><span class="fa fa-expand"></span></div>
      </div> -->
    </div>
    <div *ngIf="reservation.id == expandedReservation.id" class="sub-reservation-container">
      <div class="sub-reservation-header">
        <div class="image">{{ 'bikeshop.rentals.products.image' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.brand' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.model' | translate }}</div>
        <div style="flex:1.5">{{ 'bikeshop.rentals.products.color' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.size' | translate }}</div>
        <div>{{ 'bikeshop.rentals.summary.waiver_signed' | translate }}</div>
        <div>{{ 'bikeshop.rentals.products.serial_number' | translate }}</div>
        <div class="action"></div>


      </div>
      <div *ngFor="let item of reservation.reservationProducts" class="sub-reservation-row">
        <div class="image">
          <div *ngIf="item.imageURL"><img [src]="item.imageURL"></div>
          <div *ngIf="!item.imageURL"><img src="../../../../../../../../assets/no-product-image.png"></div>
        </div>
        <div>{{item.brand}}</div>
        <div>{{item.model}}</div>
        <div style="flex:1.5">{{item.color}}</div>
        <div>{{item.size}}</div>
        <div class="bold" [ngClass]="{'green': item.waiverSigned, 'red': !item.waiverSigned}">{{(item.waiverSigned ?
          'general.yes' : 'general.no') | translate}}</div>
        <div class="identifier">
          <div>{{item.serialNumber}}</div>
        </div>
        <div class="action"></div>
      </div>
      <div *ngFor="let item of getProductAccessories(reservation)" class="sub-reservation-row">
        <div class="image">
          <div *ngIf="item.imageURL"><img [src]="item.imageURL"></div>
          <div *ngIf="!item.imageURL"><img src="../../../../../../../../assets/no-product-image.png"></div>
        </div>
        <div>{{item.brand}}</div>
        <div>{{item.name}}</div>
        <div style="flex:1.5">{{item.color}}</div>
        <div>{{item.size}}</div>
        <div></div>
        <div class="identifier">
          <div>{{item.serialNumber}}</div>
        </div>
        <div class="action"></div>
      </div>
    </div>
  </div>


  <div *ngIf="InOrOut === 'SEARCH' && !loading && reservationData.length === 0" class="no-reservations">
    {{ 'bikeshop.rentals.summary.no_matching_search_results' | translate }}
  </div>
  <div *ngIf="InOrOut !== 'SEARCH' && !loading && reservationData.length === 0" class="no-reservations">
    {{ (InOrOut === 'IN' ? 'bikeshop.rentals.summary.no_rentals_returning' :
    'bikeshop.rentals.summary.no_rentals_going_out') | translate }}
  </div>

</div>

<p-sidebar #NavSideBar [(visible)]="showRentalReservation" position="right"
  [autoZIndex]="false"
  [style]="{width:'950px', background: '#FAFAFA', 'overflow-x': 'auto','z-index': '1001'}"  (onHide)="reloadData(); NavSideBar.destroyModal()">
  <div *ngIf="showRentalReservation">
    <app-rental-reservation-update [reservationSummary]="selectedReservation"
                                   [categories]="categories" [brands]="brands" [sizes]="sizes"
                                   [rentalStoreRules]="rentalStoreRules" (close)="showRentalReservation=false;"></app-rental-reservation-update>
  </div>
</p-sidebar>

<p-toast position="top-center" styleClass="hubtiger-toast" />